import axios from "axios";
import { API_URL } from "../../../utils/constants";
import { toast } from "react-toastify";

export const getAzureMonitorStorageAccountApi = async (param, provider) => {
  try {
    param.params.type = 1;
    const token = localStorage.getItem('api_token');
    const endpoint = provider === "gcp" ? "gcp/compute-metrics" : "get-azure-storge-account";
    const response = await axios({
      method: "GET",
      url: `${API_URL}${endpoint}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": token ? `Bearer ${token}` : "",
      },
      data: param.params,
    });
    return response;
  } catch (e) {
    return [];
  }
};

// export const getAzureMonitorApplicationResourceNamesApi = async (param) => {
//   try {
//     param.params.type = 1;
//     const response = await axios({
//       method: "POST",
//       url: `${API_URL}get-azure-moniter-resource`,
//       headers: { "Content-Type": "application/json" },
//       data: param.params,
//     });
//     return response;
//   } catch (e) {
//     return [];
//   }
// };
